function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconB2BClosed = function SvgIconB2BClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M355.38 147.329a16 16 0 1 0 16 16 16.018 16.018 0 0 0-16-16Zm0 29.694a13.694 13.694 0 1 1 13.694-13.694 13.709 13.709 0 0 1-13.694 13.694Z",
    transform: "translate(-339.38 -147.329)",
    style: {
      fill: "#f93232"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.941 167.39-4.753 4.753-4.753-4.753-1.993 1.993 4.753 4.753-4.753 4.753 1.993 1.993 4.753-4.753 4.753 4.753 1.993-1.993-4.753-4.753 4.753-4.753Z",
    transform: "translate(-350.187 -158.136)",
    style: {
      fill: "#f93232"
    }
  }));
};
export default SvgIconB2BClosed;